<h2 class="contacts-title"[i18nKey]="'mail.box.address.book'"></h2>
<div class="contactGroup">
    <div class="contactGroup-header">
        <h3 class="contactGroup-header-title"[i18nKey]="'mail.box.address.book.animators'"></h3>
        <add-button labelKey="mail.box.address.book.animators.add.all" (click)="onAddAnimators()" [dataCy]="'add-all-animators'"></add-button>
    </div>
    <div class="contactGroup-firstChild" *ngIf="mainAnimator">
        <i class="contactGroup-firstChild-userIcon fas fa-user-circle"></i>
        <div class="userInfos">
            <span class="userInfos-name">{{mainAnimator.person.firstName}} {{mainAnimator.person.lastName}}</span>
            <span class="userInfos-type"[i18nKey]="'mail.box.address.book.main.animator'"></span>
        </div>
        <i class="contactGroup-firstChild-add fas fa-plus" (click)="onAddUser(mainAnimator)"></i>
    </div>
    <ng-container *ngIf="coAnimators">
        <div class="contactGroup-firstChild" *ngFor="let animator of coAnimators">
            <i class="contactGroup-firstChild-userIcon fas fa-user-circle"></i>
            <div class="userInfos">
                <span class="userInfos-name">{{animator.person.firstName}} {{animator.person.lastName}}</span>
                <span class="userInfos-type"[i18nKey]="'mail.box.address.book.co.animator'"></span>
            </div>
            <i class="contactGroup-firstChild-add fas fa-plus" (click)="onAddUser(animator)"></i>
        </div>
    </ng-container>
</div>
<div class="contactGroup" *ngIf="teams">
    <div class="contactGroup-header">
        <h3 class="contactGroup-header-title"[i18nKey]="'mail.box.address.book.teams'"></h3>
        <add-button labelKey="mail.box.address.book.teams.add.all" (click)="onAddAllTeams()" [dataCy]="'add-all-teams'"></add-button>
    </div>
    <ng-container *ngFor="let team of teams; index as i">
        <div class="contactGroup-firstChild">
            <i class="contactGroup-firstChild-collapseIcon fas fa-angle-down" (click)="toggleDisplayPlayers(i)"></i>
            <div class="userInfos">
                <span class="userInfos-name">{{team.name}}</span>
                <span class="userInfos-type">{{team.players.length}}
                    {{('mail.box.address.book.teams.player' | translate) + (team.players.length > 2 ? 's' : '')}}
                </span>
            </div>
            <i class="contactGroup-firstChild-add fas fa-plus" (click)="onAddTeam(team)"></i>
        </div>
        <ng-container *ngIf="displayPlayers[i]">
            <div class="contactGroup-secondChild" *ngFor="let player of team.players">
                <i class="contactGroup-secondChild-userIcon fas fa-user-circle"></i>
                <span
                    class="contactGroup-secondChild-name">{{player.person.firstName}} {{player.person.lastName}}</span>
                <i class="contactGroup-secondChild-add fas fa-plus" (click)="onAddUser(player)"></i>
            </div>
        </ng-container>
    </ng-container>
</div>
